export const apiUrl = process.env.REACT_APP_URL;
export const apiUrlPublic = process.env.REACT_APP_URL_PUBLIC;

export const stripeApiKey = process.env.REACT_APP_STRIPE_KEY;